import { ICallerDetail, ICallerHistoryEntry } from '../types';
import {
  Card,
  SectionLabel,
  HistoryList,
  HistoryEntry,
  HistoryTop,
  HistoryText,
  HistoryNote,
  RebookChip,
  CenterRow,
  Chip,
} from './detail-styles';
import chevronDownIcon from '../icons/chevron-down.svg';

type Props = {
  detail: ICallerDetail;
  onRebook?: (entry: ICallerHistoryEntry) => void;
  onSeeMore?: () => void;
};

// HISTORY section — previews the 2 most recent visits with a Re Book chip;
// "See more" opens the full BOOKING HISTORY modal.
const HistorySection = ({ detail, onRebook, onSeeMore }: Props) => (
  <Card>
    <SectionLabel>HISTORY</SectionLabel>
    <HistoryList>
      {detail.history.slice(0, 2).map((entry, i) => (
        <HistoryEntry key={`${entry.date}-${i}`}>
          <HistoryTop>
            <HistoryText>
              <span className="date">{entry.date}</span>
              <span className="ser">{`Ser: ${entry.services}`}</span>
            </HistoryText>
            <RebookChip type="button" onClick={() => onRebook?.(entry)}>
              Re Book
            </RebookChip>
          </HistoryTop>
          {entry.note && (
            <HistoryNote>
              <span className="label">Note:</span> {entry.note}
            </HistoryNote>
          )}
        </HistoryEntry>
      ))}
    </HistoryList>
    <CenterRow>
      <Chip type="button" onClick={onSeeMore}>
        See more
        <img src={chevronDownIcon} alt="" />
      </Chip>
    </CenterRow>
  </Card>
);

export default HistorySection;
